import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { withRouter } from "react-router";

const EscalaLineal = (props) => {
  const [de, setDe] = useState(
    props.valorOpcion
      ? parseInt(props.valorOpcion.valor) > 1
        ? 1
        : parseInt(props.valorOpcion.valor)
      : null
  );
  const [hasta, setHasta] = useState(
    props.valorOpcion
      ? parseInt(props.valorOpcion.valor) < 2
        ? 2
        : parseInt(props.valorOpcion.valor)
      : null
  );

  const addValue = (_de, _hasta) => {
    if (props.opciones) {
      let _opciones = props.opciones;
      setTimeout(() => {
        if (parseInt(props.index) === parseInt(0)) {
          _opciones[props.index].valor = _de;
        } else {
          _opciones[props.index].valor = _hasta;
        }
        props.setOpciones(_opciones);
      }, 2000);
    }
  };
  return (
    //   <Form.Group>
    <Row>
      <Form.Group as={Col} className="mb-3" xs="6" sm="6" md="6" lg="6" xl="6">
        {/* <Row> */}
        {parseInt(props.index) === parseInt(0) && (
          <Row className="d-flex flew-wrap justify-content-between align-items-between">
            <Col xs="3" sm="3" md="3" lg="3" xl="3">
              <Button
                variant="light"
                size="sm"
                className="rounded-circle"
                // onClick={() => addArea()}
                disabled
              >
                <h5>Desde:</h5>
              </Button>
            </Col>
            <Col xs="8" sm="8" md="8" lg="8" xl="8">
              <Form.Control
                id={`inicio ${props.indexPregunta}${props.index}`}
                name="inicio"
                className="rounded-pill"
                required
                type="number"
                pattern="[0-9]+"
                min="0"
                max="1"
                // defaultValue={
                //   props.valorOpcion
                //     ? parseInt(props.valorOpcion.valor) > 1
                //       ? 1
                //       : parseInt(props.valorOpcion.valor)
                //     : null
                // }
                value={de}
                onChange={(e) => {
                  // e.preventDefault();
                  // setTimeout(() => {
                  setDe(e.currentTarget.value);
                  addValue(e.currentTarget.value, hasta);
                  // }, 1000);
                }}
                // onChange={onSubmitValueD}
                placeholder="1"
              ></Form.Control>
            </Col>
          </Row>
        )}
        {parseInt(props.index) === parseInt(1) && (
          <Row className="d-flex flew-wrap justify-content-between align-items-between">
            <Col xs="3" sm="3" md="3" lg="3" xl="3">
              <Button
                variant="light"
                size="sm"
                className="rounded-circle"
                // onClick={() => addArea()}
                disabled
              >
                <h5>Hasta:</h5>
              </Button>
            </Col>
            <Col xs="8" sm="8" md="8" lg="8" xl="8">
              <Form.Control
                id={`fin ${props.indexPregunta}${props.index}`}
                name="fin"
                className="rounded-pill"
                required
                type="number"
                pattern="[0-9]+"
                // defaultValue={
                //   props.valorOpcion
                //     ? parseInt(props.valorOpcion.valor) < 2
                //       ? 2
                //       : parseInt(props.valorOpcion.valor)
                //     : null
                // }
                value={hasta}
                onChange={(e) => {
                  // e.preventDefault();
                  // setTimeout(() => {
                  setHasta(e.currentTarget.value);
                  addValue(de, e.currentTarget.value);
                  // }, 1000);
                }}
                // onChange={onSubmitValueH}
                min="2"
                max="10"
                placeholder="2"
              ></Form.Control>
            </Col>
          </Row>
        )}
        {/* </Row> */}
      </Form.Group>
    </Row>
    // </Form.Group>
  );
};

export default withRouter(EscalaLineal);
